import React from 'react';
export function ProductComparison() {
  return <section className="mb-24" data-id="element-370">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-371">
        What Makes Our Formula Different
      </h2>
      <div className="overflow-x-auto bg-white rounded-lg shadow-md border border-[#7F8C8D]/10" data-id="element-372">
        <table className="min-w-full border-collapse" data-id="element-373">
          <thead data-id="element-374">
            <tr data-id="element-375">
              <th className="p-4 text-left bg-[#FFF8F3] text-[#1B2951] border-b border-[#7F8C8D]/10 font-['Poppins']" data-id="element-376"></th>
              <th className="p-4 text-center bg-[#FFF8F3] text-[#1B2951] border-b border-[#7F8C8D]/10 font-['Poppins']" data-id="element-377">
                Regular Collagen
              </th>
              <th className="p-4 text-center bg-[#FFF8F3] text-[#1B2951] border-b border-[#7F8C8D]/10 font-['Poppins']" data-id="element-378">
                Setu Skin: Youthful Original
              </th>
              <th className="p-4 text-center bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] font-bold border-b border-[#FFB88C]/50 font-['Poppins']" data-id="element-379">
                Setu Skin: Youthful UPGRADED
              </th>
            </tr>
          </thead>
          <tbody className="font-['Inter']" data-id="element-380">
            <tr data-id="element-381">
              <td className="p-4 text-left border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-382">
                Collagen
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-383">
                5g collagen
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-384">
                5g marine collagen
              </td>
              <td className="p-4 text-center border-b border-[#FFB88C]/20 text-[#1B2951] bg-[#FFE5D9]/30 font-medium" data-id="element-385">
                8g marine collagen
              </td>
            </tr>
            <tr data-id="element-386">
              <td className="p-4 text-left border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-387">
                Special Ingredient
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-388">
                -
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-389">
                -
              </td>
              <td className="p-4 text-center border-b border-[#FFB88C]/20 text-[#1B2951] bg-[#FFE5D9]/30 font-medium" data-id="element-390">
                CERAMOSIDES™
              </td>
            </tr>
            <tr data-id="element-391">
              <td className="p-4 text-left border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-392">
                Technology
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-393">
                -
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-394">
                -
              </td>
              <td className="p-4 text-center border-b border-[#FFB88C]/20 text-[#1B2951] bg-[#FFE5D9]/30 font-medium" data-id="element-395">
                Cerafusion™ Technology
              </td>
            </tr>
            <tr data-id="element-396">
              <td className="p-4 text-left border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-397">
                Results Timeline
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-398">
                90-day results
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-399">
                60-90 day results
              </td>
              <td className="p-4 text-center border-b border-[#FFB88C]/20 text-[#1B2951] bg-[#FFE5D9]/30 font-bold" data-id="element-400">
                15-day visible results
              </td>
            </tr>
            <tr data-id="element-401">
              <td className="p-4 text-left border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-402">
                Price
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-403">
                ₹899/month
              </td>
              <td className="p-4 text-center border-b border-[#7F8C8D]/10 text-[#2C3E50]" data-id="element-404">
                ₹1,299/month
              </td>
              <td className="p-4 text-center border-b border-[#FFB88C]/20 text-[#1B2951] bg-[#FFE5D9]/30 font-medium" data-id="element-405">
                ₹1,649/month
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}